// src/redux/slices/iframeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interpreterIframeUrl: null,
  appid: null,
};

const interpreterIframeSlice = createSlice({
  name: "interpreterIframe",
  initialState,
  reducers: {
    setInterpreterIframeUrl: (state, action) => {
      state.interpreterIframeUrl = action.payload;
    },
    setInterpreterAppid: (state, action) => {
      state.appid = action.payload;
    },
    clearInterpreterIframeUrl: (state) => {
      state.interpreterIframeUrl = null;
      state.appid = null;
    },
  },
});

export const { setInterpreterIframeUrl, setInterpreterAppid, clearInterpreterIframeUrl } = interpreterIframeSlice.actions;
export default interpreterIframeSlice.reducer;
